// extracted by mini-css-extract-plugin
var _1 = "ra-caption-figure";
var _2 = "ra-caption-figure-text";
var _3 = "ra-caption-figure-text-left";
var _4 = "ra-caption-figure-text-right";
export { _1 as "captionFigureCls", _2 as "captionFigureTextCls", _3 as "captionFigureTextLeftCls", _4 as "captionFigureTextRightCls" }
